<template>
  <div class="card">
    <div class="card-header" v-if="header || $slots.header">
      <span v-if="header">{{ header }}</span>
      <slot v-else name="header"></slot>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    header: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  border-radius: 4px;
  overflow: hidden;

  &-header {
    font-size: 14px;
    padding: 10px 15px;
    background: #FAFAFA;
  }

  &-body {
    padding: 15px 15px 0;
    border: 1px solid #f5f5f5;

  }

  /deep/ .el-form {
    margin: 0;
  }

  /deep/ .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .el-form-item__label {
    color: #000000A6;
    font-weight: normal;
  }

  /deep/ .el-form-item__content {
    color: #101626;
  }

  /deep/ .el-button--medium {
    padding: 0 0 0 20px;
  }
}
</style>